import { computed } from "vue";
import { usePortalSecuritySettings } from "@/composables/Security/usePortalSecuritySettings";
import { useParametersStore } from "@/stores/parameters";

export function useMiscSecuritySettings() {
  const parametersStore = useParametersStore();
  const portalSecuritySettings = usePortalSecuritySettings();

  const showContactUsPage = computed(
    () =>
      parametersStore.parameterSettings.showContactUs &&
      !portalSecuritySettings.managerAccountSelected.value
  );

  const showLicensesPage = computed(
    () =>
      parametersStore.parameterSettings.showLicenses &&
      !portalSecuritySettings.managerAccountSelected.value
  );

  const showFieldAlyticsPage = computed(
    () =>
      parametersStore.parameterSettings.showFieldAlytics &&
      !!parametersStore.parameterSettings.fieldAlyticsUrl?.trim() &&
      !portalSecuritySettings.managerAccountSelected.value
  );

  const showMiscMenu = computed(
    () =>
      showContactUsPage.value ||
      showLicensesPage.value ||
      showFieldAlyticsPage.value
  );

  return {
    showContactUsPage,
    showLicensesPage,
    showFieldAlyticsPage,
    showMiscMenu,
  };
}
